/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardReissuePhysical
 */
export interface CardReissuePhysical {
    /**
     * 
     * @type {string}
     * @memberof CardReissuePhysical
     */
    'cardType': CardReissuePhysicalCardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof CardReissuePhysical
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardReissuePhysical
     */
    'isRenewalProcessing': boolean;
}

export const CardReissuePhysicalCardTypeEnum = {
    physical: 'physical'
} as const;

export type CardReissuePhysicalCardTypeEnum = typeof CardReissuePhysicalCardTypeEnum[keyof typeof CardReissuePhysicalCardTypeEnum];


